module.exports = __webpack_public_path__ + "img/gw.4134431e.png";